import React, { setGlobal } from "reactn";

import PropTypes from "prop-types";

// components
import FormGroup from "../../../_common/form/form_group/FormGroup";
import InputGroup from "../../../_common/form/input_group/InputGroup";
import NumberInputManual from "../../../_common/form/number_input/NumberInputManual";
import Tabs from "../../../_common/form/tabs/Tabs";
import Tab from "../../../_common/form/tab/Tab";
import TabsConent from "../../../_common/form/tabs_content/TabsContent";

const PaymentOptions = props => {
    const { values, handleSubmit } = props;

    const setPaymentOption = option => {
        setGlobal({
            values: { ...values, paymentOption: option }
        });
    };

    return (
        <>
            {window.collectorsCorner && (
                <>
                    <FormGroup>
                        <InputGroup>
                            <Tabs>
                                <Tab active={values.paymentOption === "topUpOption" ? true : false} click={() => setPaymentOption("topUpOption")}>
                                    Top-up Account
                                </Tab>
                                <Tab active={values.paymentOption === "continuousDebit" ? true : false} click={() => setPaymentOption("continuousDebit")}>
                                    Continuous Debit Authority
                                </Tab>
                            </Tabs>
                        </InputGroup>
                        <TabsConent active={values.paymentOption === "topUpOption" ? true : false}>
                            <NumberInputManual numberValue="topUpValue" values={values} min={40} handleSubmit={handleSubmit}></NumberInputManual>
                        </TabsConent>
                        <TabsConent active={values.paymentOption === "continuousDebit" ? true : false}>
                            <div>
                                <p>I agree to allow An Post my card as required to maintain my An Post Collectors Account</p>
                            </div>
                        </TabsConent>
                    </FormGroup>
                </>
            )}
            {window.collectorsCornerTopUp && (
                <>
                    <NumberInputManual numberValue="topUpValue" values={values} min={40} handleSubmit={handleSubmit}></NumberInputManual>
                </>
            )}
        </>
    );
};

PaymentOptions.propTypes = {
    handleChange: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object
};

export default PaymentOptions;
